/** Salto de un módulo a la factura o al remito que el usuario eligió. */

export type DocFocus =
  | { kind: "factura"; id: number; token: number }
  | { kind: "remito"; numero: string; clienteId: number; estado: string; token: number };

let current: DocFocus | null = null;
let seq = 0;
const listeners = new Set<() => void>();

export function requestDocFocus(focus: Omit<DocFocus, "token">): void {
  current = { ...focus, token: ++seq } as DocFocus;
  listeners.forEach((listener) => listener());
}

export function peekDocFocus(): DocFocus | null {
  return current;
}

export function clearDocFocus(token: number): void {
  if (current?.token === token) current = null;
}

export function subscribeDocFocus(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
